import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <span className="footer-text">Jericho F. · 2025</span>
        <div className="footer-links">
          <a href="https://github.com/jericho0521" target="_blank" rel="noopener noreferrer" className="footer-link">
            GitHub ↗
          </a>
          <a href="https://linkedin.com/in/jerichofoong" target="_blank" rel="noopener noreferrer" className="footer-link">
            LinkedIn ↗
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
